import { render, staticRenderFns } from "./purchaseApplyManageList.vue?vue&type=template&id=65b9b62d&scoped=true"
import script from "./purchaseApplyManageList.vue?vue&type=script&lang=js"
export * from "./purchaseApplyManageList.vue?vue&type=script&lang=js"
import style0 from "./purchaseApplyManageList.vue?vue&type=style&index=0&id=65b9b62d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9b62d",
  null
  
)

export default component.exports